import http from './http';

export default {
    getAll() {
        return http.get('/user');
    },
    create(wada) {
        return http.post('/user', wada);
    },
    update(wada) {
        return http.patch(`/user/${wada.id}`, wada);
    },
    delete({ id }) {
        return http.delete(`/user/${id}`);
    },
};
